<template>
  <div class="text-options-data-dialog">
    <div
      :class="detailFieldMappingFieldFlag && detailFiledMappingChecked ? 'mapping_content checked' : 'mapping_content'"
    >
      <div class="verticallyBetweenCenter">
        <div class="content-title">
          {{ getValueByTypeHandle(options.innerElement) }}
        </div>
        <div class="verticallyCenter" v-if="options.innerElement == 'cxText' || options.innerElement == 'cxLabel'">
          <el-checkbox v-model="textHyperlink" v-if="options.innerElement == 'cxText'">超链接</el-checkbox>
          <el-checkbox v-model="isHyperlink" v-else>超链接</el-checkbox>
        </div>
      </div>
      <div class="select_content mt8">
        <el-select style="width: 100%" v-model="detailFieldMappingFieldFlag" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in detailFieldMappingList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mapping_date_content mt8" v-if="options.innerElement !== 'imageComponent'">
        <label class="date-label">显示为:</label>
        <el-dropdown trigger="click" @command="onChangeMappingType">
          <span class="el-dropdown-link">
            {{ fieldMappingDataType }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="custom-dropdown">
            <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
              <div :class="detailFieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                {{ item.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="select_content mt8" v-if="options.isHyperlink">
        <el-select style="width: 100%" v-model="detailFieldMappingLinkField" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in detailFieldMappingList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mt4" v-if="options.isHyperlink">
        <el-checkbox v-model="options.openBlankPage">新页面打开</el-checkbox>
      </div>
      <div v-if="options.innerElement == 'cxVideo' || options.innerElement == 'cxAudio'" class="vedio-style mt8">
        <el-checkbox v-model="videoObjectId"></el-checkbox><label>支持云盘</label>
      </div>
    </div>
  </div>
</template>

<script>
import { getValueByType } from "utils"
export default {
  name: "listPageFieldMappingSetting",
  components: {},
  props: {
    myid: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      dataTypeList: [
        {
          label: "字段名称：字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        }
      ],
      detailFieldMappingList: [] // 详情页数据源
    }
  },
  computed: {
    detailFieldMapping() {
      if (!this.options.detailFieldMapping) {
        this.$changeOptionsEV({}, "detailFieldMapping", false, null, {
          ...this.myid
        })
      }
      return this.options.detailFieldMapping
    },
    detailFiledMappingChecked: {
      get() {
        return this.detailFieldMapping.isChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping.isChecked", false, null, {
          ...this.myid
        })
      }
    },
    detailFieldMappingDataType: {
      get() {
        return this.detailFieldMapping.dataType || "dataValue"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping.dataType", false, null, {
          ...this.myid
        })
      }
    },
    detailFieldMappingFieldFlag: {
      get() {
        return this.detailFieldMapping.fieldFlag
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, !!newVal],
          ["detailFieldMapping.fieldFlag", "detailFieldMapping.isChecked"],
          false
        )
        if (this.options.innerElement === "cxNoteEditor") {
          // 笔记编辑器 匹配字段的同时修改 noCacheComponent
          if (newVal) this.$changeOptionsEV(true,"noCacheComponent",false)
          else this.$changeOptionsEV(false,"noCacheComponent",false)
        }
      }
    },
    textHyperlink: {
      get() {
        return this.options.textHyperlink
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textHyperlink", false, null, {
          ...this.myid
        })
      }
    },
    detailFieldMappingLinkField: {
      get() {
        return this.detailFieldMapping.linkField
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "detailFieldMapping.linkField", false, null, {
          ...this.myid
        })
      }
    },
    isHyperlink: {
      get() {
        return this.options.isHyperlink
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isHyperlink", false, null, {
          ...this.myid
        })
      }
    },
    videoObjectId: {
      get() {
        return this.options.videoObjectId
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoObjectId", false, null, {
          ...this.myid
        })
      }
    },
    fieldMappingDataType() {
      const item = this.dataTypeList.find(data => data.value === this.detailFieldMappingDataType)
      return item?.label || ""
    }
  },
  watch: {
    textHyperlink: {
      immediate: true,
      handler: function (n, o) {
        if (n) {
          this.dataTypeList.push({
            label: "字段名称",
            value: "dataName"
          })
        } else {
          this.dataTypeList.splice(2, 1)
        }
      }
    },
    videoObjectId: {
      immediate: true,
      handler: function (n, o) {
        if (n) {
          this.dataTypeList.push({
            label: "objectId",
            value: "dataObjectId"
          })
        } else {
          this.dataTypeList.splice(2, 1)
        }
      }
    }
  },
  methods: {
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    onChangeMappingType(value) {
      this.detailFieldMappingDataType = value
    }
  },
  mounted() {
    const appId = this.$store.state.states.getDataPageIds.appId
    this.$nextTick(()=>{
      if (window.localStorage.getItem("classifyDetailData-" + appId)) {
      const classifyDetailData = JSON.parse(window.localStorage.getItem("classifyDetailData-" + appId))[0]
      Object.keys(classifyDetailData).forEach((key, index) => {
        const temp = {
          value: key,
          label: classifyDetailData[key].key
        }
        this.detailFieldMappingList.push(temp)
      })
    }
    })
  }
}
</script>

<style lang="scss" scoped>
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
  .verticallyBetweenCenter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.text_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
  .el-checkbox {
    margin-right: 4px;
  }
  ::v-deep .el-input .el-input__inner {
    background-color: var(--leftMenuBgColor);
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
</style>
